import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

/**
 * @typedef MenuOptions
 * @property {number} breakPoint
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string }} [overlay]
 */

export const MainMenu = {
    breakPoint: 1700,
    selector: '.main-nav',
    navButton: 'header .nav-button',
    overlay: {
        element: '#nav-overlay',
        close: '#nav-close',
    },
};

function moveMainNav() {
    const mainNav = document.querySelector('.main-nav');
    const header = document.querySelector('#header .header_inside');
    const overlay = document.getElementById('nav-content');

    if (window.innerWidth < MainMenu.breakPoint) {
        if (mainNav.closest('#nav-content')) {
            return;
        }

        overlay.append(mainNav);
    } else {
        if (mainNav.closest('.header_inside')) {
            return;
        }

        header.prepend(mainNav);
    }
}

onDomReady(() => {
    new DropdownMenu(MainMenu);
    moveMainNav();
});

window.addEventListener('resize', () => {
    moveMainNav();
});
